import { render, staticRenderFns } from "./-faq-list.vue?vue&type=template&id=e34a13d2&scoped=true&"
import script from "./-faq-list.vue?vue&type=script&lang=js&"
export * from "./-faq-list.vue?vue&type=script&lang=js&"
import style0 from "./-faq-list.vue?vue&type=style&index=0&id=e34a13d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34a13d2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Pagination: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/pagination/index.vue').default})
